const creditParameterMap = {
    "Cheque Bounce": "When you issue a cheque or an ECS, you are giving a commitment and making a promise, bouncing " +
        "a cheque or ECS is breaking a commitment and therefore reflects poorly on your report card.",
    "Emi to Income": "This takes into account your total EMIs as percentage of your total income, higher the " +
        "current EMIs lower the incremental EMI that individual can afford.",
    "Income": "You capacity to pay depends on your current income, therefore higher the income bracket " +
        "higher the paying capacity.",
    "Bank History": "Credit scoring relies a lot on your bank history, therefore it's important to have a long " +
        "banking relationship since it helps in building your credit score. The longer your bank relationship " +
        "better will be your credit.",
    "Bank Balance": "The average bank balance is an indicator of your disposable income after all the expenses and" +
        " the loans have been paid for.",
    "Cash Withdrawal": "Credit reports are built based on your transaction history, lenders want to know more about" +
        " you and one of the important source is bank transactions. It's recommended to do more and more transactions" +
        " either through debit cards or bank to bank transfer so credit report can get adequate inputs.",
    "Education": "Higher the education qualifications, better the prospects of a job and better score.",
    "Job Tenure": "The total number of years in employment. Higher the years in employment, better the score.",
    "Insurance": "Insurance is an important aspect in the loan process. Insurance secures you from unforeseen" +
        " health/hospital expenses. We recommended that insurance is taken.",
    "Soft Connections": "",
    "Identity": "It's only natural for the lenders to make sure that loan is being given to the right applicant and" +
        " therefore all efforts are made to ensure that their identity is verified, poor identity score can mean that" +
        " applicant has misrepresented themselves erroneously or deliberately.",
    "Employment Stability": "The longer the tenure with an employer better is your credit report card, jumping quick" +
        " jobs impacts your report card negatively.",
};

export function getParamInfo(creditParameter: string) {
    return creditParameterMap[creditParameter];
}

export function getParamScoreResult(creditParameterScore: string) {
    let scoreValue = null;
    let scoreClass = null;
    if (creditParameterScore === "EXCELLENT") {
        scoreValue = 100;
        scoreClass = "progress-bar bg-success";
    } else if (creditParameterScore === "GOOD") {
        scoreValue = 75;
        scoreClass = "progress-bar";
    } else if (creditParameterScore === "AVERAGE") {
        scoreValue = 50;
        scoreClass = "progress-bar bg-warning";
    } else {
        scoreValue = 25;
        scoreClass = "progress-bar bg-danger";
    }
    return {
        scoreValue,
        scoreClass,
    };
}
